import { render, staticRenderFns } from "./affiliations-tab.vue?vue&type=template&id=4b301483&scoped=true&"
import script from "./affiliations-tab.vue?vue&type=script&lang=tsx&"
export * from "./affiliations-tab.vue?vue&type=script&lang=tsx&"
import style0 from "./affiliations-tab.vue?vue&type=style&index=0&id=4b301483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b301483",
  null
  
)

export default component.exports